"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditButton = exports.CopyButton = exports.DollarSignButton = exports.AddButton = exports.CloseButton = exports.ExpandMenuButton = exports.DownloadInvoiceButton = exports.RemoveButton = exports.UndoButton = void 0;
var faCopy_1 = require("@fortawesome/pro-light-svg-icons/faCopy");
var faFileContract_1 = require("@fortawesome/pro-light-svg-icons/faFileContract");
var faUndo_1 = require("@fortawesome/pro-regular-svg-icons/faUndo");
var faXmark_1 = require("@fortawesome/pro-regular-svg-icons/faXmark");
var faXmarkLarge_1 = require("@fortawesome/pro-regular-svg-icons/faXmarkLarge");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var faDollarSign_1 = require("@fortawesome/pro-solid-svg-icons/faDollarSign");
var faEllipsis_1 = require("@fortawesome/pro-solid-svg-icons/faEllipsis");
var faPlus_1 = require("@fortawesome/pro-solid-svg-icons/faPlus");
var IconButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/IconButton"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
exports.UndoButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: faUndo_1.faUndo,
    iconSize: 16,
    color: 'neutral',
    tooltipTitle: 'Undo',
});
exports.RemoveButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: faXmark_1.faXmark,
    iconSize: 18,
    color: 'red',
    tooltipTitle: 'Delete',
    neutralByDefault: true,
});
exports.DownloadInvoiceButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: faFileContract_1.faFileContract,
    iconSize: 16,
    color: 'neutral',
});
exports.ExpandMenuButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: faEllipsis_1.faEllipsis,
    iconSize: 16,
    color: 'neutral',
});
exports.CloseButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: faXmarkLarge_1.faXmarkLarge,
    iconSize: 16,
    color: 'neutral',
    isCircle: true,
    sx: { p: 2 },
});
exports.AddButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: faPlus_1.faPlus,
    iconSize: 16,
    color: 'green',
});
exports.DollarSignButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: faDollarSign_1.faDollarSign,
    iconSize: 16,
    color: 'green',
    tooltipTitle: 'Mark as Valid Spend',
    neutralByDefault: true,
});
exports.CopyButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: faCopy_1.faCopy,
    iconSize: 16,
    tooltipTitle: 'or Ctrl + C',
});
exports.EditButton = (0, DefaultPropsHoC_1.default)(IconButton_1.default, {
    icon: pro_solid_svg_icons_1.faPencil,
    iconSize: 14,
    outlined: true,
    neutralByDefault: true,
    tooltipTitle: 'Edit',
});
